import styled from 'styled-components'

export interface IDescriptionItemLabelStyledProps {
  verticalAlignLabel?: 'top' | 'middle'
}

export const DescriptionItemLabelStyled = styled.label<IDescriptionItemLabelStyledProps>`
  && {
    ${(props) => {
      if (props.verticalAlignLabel === 'top') {
        return `
        align-self: start;
        `
      } else if (props.verticalAlignLabel === 'middle') {
        return `
        align-self: center;
        `
      }
    }}
  }
`
